import { render } from "./FooterHinamori.vue?vue&type=template&id=9c8fc1b4&scoped=true"
import script from "./FooterHinamori.vue?vue&type=script&lang=js"
export * from "./FooterHinamori.vue?vue&type=script&lang=js"

import "./FooterHinamori.vue?vue&type=style&index=0&id=9c8fc1b4&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c8fc1b4"]])

export default __exports__